import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ChatDetailPage } from './chat-detail.page';
import { SharedModule } from '../shared-module/shared.module';
import { ChatDetailPageRoutingModule } from './chat-detail-routing.module';
import { LinkifyModule } from 'src/app/pipes/linkify/linkify.module';
// import { LinkifyPipe } from 'src/app/pipes/linkify/linkify.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    ChatDetailPageRoutingModule,
    LinkifyModule
  ],
  declarations: [
    ChatDetailPage,
    // LinkifyPipe
  ],
  exports: []
})
export class ChatDetailPageModule { }
